import { BASE_BE_URL } from "../AppEnv";
import { SignedInDoctor } from "../auth/interfaces";
import {
  ALMSG_BADREQUEST_ERR,
  ALMSG_INTERNAL_ERR,
  ALMSG_UNAUTHORIZED_OP,
  BASE_ITASK_SUBURL,
  BASE_MEDSTUDIO_SUBURL,
} from "../env";
import { emptyStudio, Studio } from "./interfaces";

const formatMsgError = (msg: string[] | undefined) => {
  if (msg == undefined) return ALMSG_INTERNAL_ERR;
  else {
    return msg[0];
  }
};

export async function getStudio(
  signedInDoctor: SignedInDoctor,
  idStudio?: number
): Promise<Studio> {
  let idMedStudio =
    idStudio == undefined && signedInDoctor.studioMaster
      ? signedInDoctor.medicalStudioId
      : idStudio != undefined
      ? idStudio
      : "show";

  try {
    //console.log("Retrieving studio with id " + idMedStudio);
    const response = await (
      await fetch(BASE_BE_URL + BASE_MEDSTUDIO_SUBURL + idMedStudio, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).json();
    //console.log("Response", response);
    return response;
  } catch (error) {
    console.log(error);
    return emptyStudio;
  }
}

export async function editStudio(
  signedInDoctor: SignedInDoctor,
  editedStudio: Studio
): Promise<string> {
  let idMedStudio: number =
    editedStudio.id == undefined && signedInDoctor.studioMaster
      ? signedInDoctor.medicalStudioId
      : editedStudio.id != undefined
      ? editedStudio.id
      : NaN;

  if (idMedStudio != NaN) {
    try {
      //console.log("Edit studio with data ", JSON.stringify(editedStudio));
      const response = await fetch(
        BASE_BE_URL + BASE_MEDSTUDIO_SUBURL + "edit",
        {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + signedInDoctor.token,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(editedStudio),
        }
      );

      if (response.ok) return JSON.stringify(await response.json());

      if (response.status == 400)
        return formatMsgError((await response.json()).message);
      else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
      else return ALMSG_INTERNAL_ERR;
    } catch (error: any) {
      return ALMSG_INTERNAL_ERR;
    }
  }
  return ALMSG_INTERNAL_ERR;
}

export async function uploadNewLogo(
  signedInDoctor: SignedInDoctor,
  studio: Studio,
  selectedImage: File
): Promise<string> {
  const formData = new FormData();

  formData.append("file", selectedImage);
  formData.append(
    "forceFilename",
    studio.nameSignIn +
      "-logo." +
      selectedImage.type.substring(selectedImage.type.lastIndexOf("/") + 1)
  );
  try {
    //console.log("Upload logo of studio with data ", JSON.stringify(studio));
    const response = await fetch(
      BASE_BE_URL + BASE_ITASK_SUBURL + "upload-studio-img",
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
        },
        body: formData,
      }
    );

    if (response.ok) {
      return JSON.stringify(await response.json());
    } else if (response.status == 400) return ALMSG_BADREQUEST_ERR;
    else if (response.status == 401) return ALMSG_UNAUTHORIZED_OP;
    else return ALMSG_INTERNAL_ERR;
  } catch (error: any) {
    return ALMSG_INTERNAL_ERR;
  }
}

export async function getStudioLogoImg(
  signedInDoctor: SignedInDoctor,
  studio: Studio
): Promise<Blob | undefined> {
  const img_url = BASE_BE_URL + BASE_ITASK_SUBURL + "see-img/" + studio.logo;
  try {
    console.log("Retrieving logo of studio with url " + img_url);
    const response = await (
      await fetch(img_url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + signedInDoctor.token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
    ).blob();
    return response;
  } catch (error) {
    console.log(error);
  }
}

/*
export async function delStudioOldLogoImg(
  signedInDoctor: SignedInDoctor,
  studio: Studio
) {
  const img_url = BASE_BE_URL + BASE_ITASK_SUBURL + "del-img/" + studio.oldLogo;
  try {
    console.log("Deleting old logo of studio with id " + studio.id);
    await fetch(img_url, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + signedInDoctor.token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.log(error);
  }
}
*/
